import dateformat from 'dateformat';

import getDateFromYYYYMMDDString from './get-date-from-yyyymmdd-string';

const getTravelDate = dateStr => {
  const dateObj = getDateFromYYYYMMDDString(dateStr);
  return {
    date: dateformat(dateObj, 'dd'),
    day: dateformat(dateObj, 'ddd'),
    dayOfWeek: dateformat(dateObj, 'dddd'),
    month: dateformat(dateObj, 'mmm').toUpperCase(),
    year: dateformat(dateObj, 'yyyy')
  };
};

export default getTravelDate;
